module.exports = __webpack_public_path__ + "assets/images/premium-features/labor-report-banner-new-73ae37.png";